import { Button, Spinner, Icon } from '@nike/eds'
import { ApolloClient, useApolloClient } from '@apollo/client'
import { HTMLAttributes, useState } from 'react'
import { paginatedFetchQuery } from '../../utils/FetchAll'
import { ExportQuery, exportToXlsx, XlsxColumn } from './ExportService'

export interface ExportButtonProps extends HTMLAttributes<HTMLInputElement> {
  xlsxColumns: XlsxColumn[]
  exportQuery: ExportQuery
  fileName?: string
  disabled?: boolean
  extraData?: any
  pageSize?: number
  format?: (value: any) => any
}

export function ExportButton({
  xlsxColumns,
  exportQuery,
  fileName,
  disabled = false,
  extraData,
  pageSize,
  format,
  ...otherProps
}: ExportButtonProps) {
  const client = useApolloClient()
  const [isDownloading, setIsDownloading] = useState(false)
  const isDisabled = isDownloading || disabled

  function exportXlsx(
    client: ApolloClient<object>,
    xlsxColumns: XlsxColumn[],
    exportQuery: ExportQuery,
    fileName = 'export.xlsx',
    format: (value: any) => any
  ) {
    setIsDownloading(true)
    paginatedFetchQuery(client, exportQuery, pageSize)
      .then((data) => {
        data = format ? format(data) : data
        exportToXlsx(data, xlsxColumns, fileName, extraData)
        setIsDownloading(false)
      })
      .catch((error) => {
        console.error(error)
        alert(error)
        setIsDownloading(false)
      })
  }

  return (
    <Button
      className={(isDownloading || isDisabled) && 'eds-button--disabled'}
      style={{
        padding: 'var(--eds-space-8) var(--eds-space-8) var(--eds-space-8) var(--eds-space-8)',
      }}
      disabled={isDisabled}
      size="medium"
      variant="primary"
      onClick={() => {
        exportXlsx(client, xlsxColumns, exportQuery, fileName, format)
      }}
      {...otherProps}
      beforeSlot={<Icon name="Download" />}
    >
      Export Results
      <div className="eds--dark">{isDownloading && <Spinner />}</div>
    </Button>
  )
}
